Controller.$inject = ['$timeout', '$element'];

function Controller($timeout, $element) {
    let self = this;

    self.maxVisible = parseInt(self.maxVisible) || 5;
    self.sizing = self.sizing || 'sm';
    self.showMoreCount = self.showMoreCount !== 'false';
    self.reverseOrder = self.reverseOrder === 'true';

    self.moreCount = 0;

    self.$postLink = () => {
        $timeout(() => {
            self.updateAvatarStacking();
        }, 100);
    };

    self.updateAvatarStacking = () => {
        const container = $element.find('.avatar-group-container')[0];

        if (!container) {
            console.warn('Avatar group container not found');
            return;
        }

        const avatars = container.querySelectorAll('.hui-avatar');
        const totalAvatars = avatars.length;

        if (totalAvatars > self.maxVisible) {
            Array.from(avatars).forEach((avatar, index) => {
                if (index >= self.maxVisible) {
                    avatar.style.setProperty('display', 'none');
                } else {
                    avatar.style.setProperty('display', '');
                    self.applyStackingStyles(avatar, index);
                }
            });

            self.moreCount = totalAvatars - self.maxVisible;
            
            $timeout(() => {
                const moreCountElement = container.querySelector('.more-count');
                if (moreCountElement) {
                    self.applyMoreCountStacking(moreCountElement);
                }
            }, 0);
        } else {
            Array.from(avatars).forEach((avatar, index) => {
                avatar.style.setProperty('display', '');
                self.applyStackingStyles(avatar, index);
            });

            self.moreCount = 0;
        }
    };

    self.applyStackingStyles = (avatar, index) => {
        let zIndex;
        if (self.reverseOrder) {
            zIndex = 100 + (self.maxVisible - 1 - index);
        } else {
            zIndex = 100 + index;
        }

        avatar.style.setProperty('z-index', zIndex.toString());
    };

    self.applyMoreCountStacking =  (moreCountElement) => {
        const lastVisibleIndex = self.maxVisible - 1;

        let lastAvatarZIndex;
        if (self.reverseOrder) {
            lastAvatarZIndex = 100 + (self.maxVisible - 1 - lastVisibleIndex);
        } else {
            lastAvatarZIndex = 100 + lastVisibleIndex;
        }

        let moreCountZIndex;
        if (self.reverseOrder) {
            moreCountZIndex = lastAvatarZIndex - 1;
        } else {
            moreCountZIndex = lastAvatarZIndex + 1;
        }

        moreCountElement.style.setProperty('z-index', moreCountZIndex.toString());
    };

    self.onMoreClick = () => {
        if (self.moreClicked) {
            self.moreClicked({ count: self.moreCount });
        }
    };
}

export function HuiAvatarGroup() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            maxVisible: '@?',
            showMoreCount: '@?',
            sizing: '@?',
            reverseOrder: '@?',
            moreClicked: '&?'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-avatar-group"
                     ng-class="[$huiCtrl.sizing]">
                    <div class="avatar-group-container">
                        <ng-transclude class="d-flex"></ng-transclude>
                        <div ng-if="$huiCtrl.showMoreCount && $huiCtrl.moreCount > 0"
                             class="more-count"
                             ng-class="[$huiCtrl.sizing || 'sm']"
                             title="Show {{ $huiCtrl.moreCount }} more"
                             ng-click="$huiCtrl.onMoreClick()">
                            <span class="more-text">+{{ $huiCtrl.moreCount }}</span>
                        </div>
                    </div>
                </div>
            `;
        }
    }
}